{
  "intro": "Copies of your servers' disks. Snapshots are the ones you take; they stay until you delete them. Backups are made by Hetzner every day for servers that have them on. Any copy can take a server back to an earlier state or start a new server.",
  "tabs": {
    "snapshots": "Snapshots",
    "backups": "Backups"
  },
  "status": {
    "creating": "Being created",
    "available": "Ready",
    "unavailable": "Unavailable"
  },
  "why": {
    "architecture": "image is for {{arch}}",
    "disk": "needs a disk of {{disk}}\u00a0GB or more",
    "notReady": "The copy is still being created",
    "busy": "Another change is running",
    "protected": "Delete protection is on"
  },
  "costSnapshots": "Snapshots per month",
  "costSnapshotsHint": "Snapshots are billed by the space they actually take, not by the server's disk size. While a snapshot is being created its size is not known yet.",
  "costSnapshotsLine": "Snapshots: {{count}}, {{size}} in total at {{price}} per GB",
  "costBackups": "Backups per month",
  "costBackupsHint": "Backups are not billed one by one: turning them on adds a percentage to the server's price, which covers all of its backups.",
  "costBackupsLine": "On for servers: {{count}}, {{percent}}\u00a0% of each server's price",
  "perMonth": "{{price}}",
  "description": "Description",
  "descriptionHint": "So you recognize the copy later, e.g. “before the PostgreSQL upgrade”.",
  "descriptionPlaceholder": "Before the upgrade to version 2",
  "labels": "Labels",
  "labelsInvalid": "Line {{line}}: invalid key or value.",
  "from": "Taken from server",
  "belongsTo": "Server",
  "serverGone": "server deleted",
  "size": "Size",
  "sizeHint": "How much storage the copy takes; a snapshot's price is based on it. Below it: the disk a server needs to be restored from the copy.",
  "disk": "for disks from {{disk}}\u00a0GB",
  "price": "Per month",
  "flags": "Protection and labels",
  "protected": "Protected",
  "created": "Created",
  "emptySnapshots": "No snapshots yet",
  "emptySnapshotsLead": "Take a snapshot before a risky change: if something goes wrong, the server can be taken back to it in minutes. A snapshot outlives even the server.",
  "emptyBackups": "No backups yet",
  "emptyBackupsLead": "Turn backups on on a server's page. The first copy is made in the next daily window; after that Hetzner keeps the last seven.",
  "backupServers": "Backups by server",
  "backupServersLead": "Turned on and off on the server’s “Backups & snapshots” tab.",
  "restore": "Restore a server",
  "newServer": "Create a server from the copy",
  "edit": "Edit description and labels",
  "editTitle": "Description and labels",
  "saved": "Saved",
  "protect": "Protect from deletion",
  "unprotect": "Remove protection",
  "protecting": "Protecting “{{name}}”",
  "unprotecting": "Removing protection from “{{name}}”",
  "convert": "Keep as a snapshot",
  "convertTitle": "Keep this backup as a snapshot?",
  "convertLead": "The backup “{{name}}” becomes an ordinary snapshot.",
  "convertKeeps": "The snapshot stays even if the server is deleted or its backups are turned off.",
  "convertCount": "It no longer counts among the server's seven backups and is not replaced by the next one.",
  "convertPrice": "The snapshot is billed separately by the space it takes: {{price}} per month.",
  "converted": "“{{name}}” kept as a snapshot",
  "chooseServer": "Choose a server",
  "restoreTitle": "Restore “{{server}}” from the copy?",
  "restoreTitleNoServer": "Restore a server from the copy?",
  "restoreFromBackup": "Backup “{{name}}” of {{date}}.",
  "restoreFromSnapshot": "Snapshot “{{name}}” of {{date}}.",
  "restoreServer": "Server to restore",
  "restoreData": "Everything on the disk of {{server}} is replaced by its state at {{date}}. Files and changes made since are lost.",
  "restoreReboot": "The server restarts and is unavailable for a few minutes.",
  "restoreKeep": "IP addresses, server type, private networks, firewalls and labels stay as they are.",
  "restoreTip": "If the current state may still be needed, take a snapshot of the server first.",
  "restoreAction": "Restore",
  "restoring": "Restoring “{{server}}”. This usually takes a few minutes.",
  "snapshotTitle": "Take snapshot",
  "snapshotLead": "A copy of the server's whole disk as it is now.",
  "snapshotServer": "Server",
  "snapshotCreate": "Take snapshot",
  "snapshotRunning": "The server keeps running. For a consistent copy of a busy database, shut the server down first.",
  "snapshotPrice": "A snapshot is billed by the space it takes: {{price}} per GB and month.",
  "taking": "Taking a snapshot of “{{server}}”",
  "delete": "Delete",
  "deleteTitle": "Delete “{{name}}”?",
  "deleteForever": "The copy is deleted for good: no server can be restored from it.",
  "deleteBackupOthers": "The server's other backups stay; the next one is made at the usual time.",
  "deleteSnapshotBilling": "Billing for the snapshot stops.",
  "deleted": "“{{name}}” deleted"
}
